import React, { useEffect, useState } from 'react';
import { Pie } from 'react-chartjs-2';
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import '../css/OwnerDashboard.css'; // Import the CSS file
import { findAgentsWithDetailsByOwnerId } from '../services/api';

// Register Chart.js elements and plugins
ChartJS.register(ArcElement, Tooltip, Legend, ChartDataLabels);

const generateColors = (numColors) => {
  const colors = [];
  for (let i = 0; i < numColors; i++) {
    const color = `hsl(${Math.floor(Math.random() * 360)}, 100%, 75%)`;
    colors.push(color);
  }
  return colors;
};

const OwnerDashboard = ({ userId }) => {
  const [agents, setAgents] = useState([]);
  const [chartData, setChartData] = useState({
    labels: [],
    datasets: [
      {
        data: [],
        backgroundColor: [],
      },
    ],
  });

  useEffect(() => {
    const fetchAgents = async () => {
      try {
        const userId = localStorage.getItem("userId");
        const response = await findAgentsWithDetailsByOwnerId(userId);
        setAgents(response.data);

        const cityData = response.data.reduce((acc, agent) => {
          const city = agent[2]; // Access the city data correctly
          acc[city] = (acc[city] || 0) + 1;
          return acc;
        }, {});

        const colors = generateColors(Object.keys(cityData).length);

        setChartData({
          labels: Object.keys(cityData),
          datasets: [
            {
              data: Object.values(cityData),
              backgroundColor: colors,
            },
          ],
        });
      } catch (error) {
        console.error('Error fetching agents:', error);
      }
    };

    fetchAgents();
  }, [userId]);

  return (
    <div className="dashboard-container">
      <h2>Agents List</h2>
      <div className="chart-container">
        {chartData.labels.length > 0 && (
          <Pie
            data={chartData}
            options={{
              plugins: {
                datalabels: {
                  formatter: (value, context) => {
                    return context.chart.data.labels[context.dataIndex] + ': ' + value;
                  },
                  color: '#fff',
                  font: {
                    weight: 'bold',
                  },
                },
              },
            }}
          />
        )}
      </div>
      <table className="agents-table">
        <thead>
          <tr>
            <th>Name</th>
            <th>Email</th>
            <th>City</th>
            <th>Organization</th>
            <th>Role</th>
            <th>Owner</th>
          </tr>
        </thead>
        <tbody>
          {agents.map((agent, index) => (
            <tr key={index}>
              <td>{agent[0]}</td>
              <td>{agent[1]}</td>
              <td>{agent[2]}</td>
              <td>{agent[3]}</td>
              <td>{agent[4]}</td>
              <td>{agent[5]}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default OwnerDashboard;